import React, { useState, useEffect } from "react";
import { Box, Text, Portal } from "@chakra-ui/react";
import CustomerCenterTabs from "./CustomerCenterTabs";
import { useTranslation } from "react-i18next";
import { useJournalistCustomerCenterTourGuide } from "@root/hooks/useJournalistCustomerCenterTourGuide";
import { TourGuide, RestartTourButton } from "@root/components/tour-guide";

const CustomerCenter: React.FC = () => {
  const { t } = useTranslation("common");
  const [tabIndex, setTabIndex] = useState(0);
  const { journalistCustomerCenterTourGuide, isMobile: isMobileTour } =
    useJournalistCustomerCenterTourGuide();
  const { isActive, currentStep } = journalistCustomerCenterTourGuide;

  useEffect(() => {
    if (!isActive) return;
    if (currentStep === 0) setTabIndex(0);
    else if (currentStep === 1 || currentStep === 2) setTabIndex(1);
    else if (currentStep === 3) setTabIndex(2);
  }, [isActive, currentStep]);

  return (
    <Box py={4} px={8} bg="#fafbfc" minW={"full"} minH="100vh">
      <Box minW={"full"} mx="auto">
        <Text fontWeight={600} fontSize={"24px"} color={"#2F2F34"} mb={1}>
          {t("customerCenter.customerCenterTitle")}
        </Text>
        <Text fontSize="16px" fontWeight={400} textColor={"#798692"} mb={6}>
          {t("customerCenter.customerCenterSubtitle")}
        </Text>
        <CustomerCenterTabs tabIndex={tabIndex} onTabChange={setTabIndex} />
      </Box>

      {!isMobileTour && !journalistCustomerCenterTourGuide.isActive && (
        <Portal>
          <RestartTourButton
            onClick={journalistCustomerCenterTourGuide.startTour}
            position={{ bottom: "24px", right: "24px" }}
          />
        </Portal>
      )}

      {!isMobileTour &&
        journalistCustomerCenterTourGuide.isActive &&
        journalistCustomerCenterTourGuide.currentStepData && (
          <TourGuide
            isActive={journalistCustomerCenterTourGuide.isActive}
            currentStep={journalistCustomerCenterTourGuide.currentStepData}
            currentStepIndex={journalistCustomerCenterTourGuide.currentStep}
            totalSteps={journalistCustomerCenterTourGuide.totalSteps}
            onNext={journalistCustomerCenterTourGuide.nextStep}
            onBack={journalistCustomerCenterTourGuide.previousStep}
            onClose={journalistCustomerCenterTourGuide.stopTour}
            targetSelector={
              journalistCustomerCenterTourGuide.currentStepData.targetSelector
            }
            borderRadius="8px"
          />
        )}
    </Box>
  );
};

export default CustomerCenter;
